<template>
  <div class="table-row pinned-tab">
    <!-- <div class="report-side-panel bench-overview-side-panel q-box-shadow fromleft"> -->
    <div class="report-side-panel">
      <div class="sub-header">
        <!--- <report-header></report-header>-->
        <div class="date-range">
          <!--<VueDatePicker v-model="year" :min-date="min_date" :max-date="max_date" type="year" />-->
          <div class="col position">
            <div class="select-wrapper">
              <v-select
                :options="years"
                label="year"
                clear-button-icon="false"
                v-model="year"
                @input="setYear"
              ></v-select>
            </div>
          </div>

          <div class="col position" :class="officeClassObject">
            <div class="select-wrapper">
              <v-select
                :options="teamData"
                label="TeamName"
                clear-button-icon="false"
                v-model="team"
              ></v-select>
            </div>
          </div>
          <div class="col position">
            <div class="select-wrapper">
              <v-select
                :options="employeeData"
                label="EmployeeName"
                clear-button-icon="false"
                v-model="employee"
              ></v-select>
            </div>
          </div>
          <div class="download-button-wrapper">
            <a
              data-v-200367fa
              href
              class="cta-btn release-btn"
              @click.prevent="exportExcel()"
            >Download</a>
          </div>
          <!-- <i class="csv-export button-export" @click.stop="exportExcel()"></i> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import VueMonthlyPicker from "vue-monthly-picker"; //https://www.npmjs.com/package/vue-monthly-picker
import _ from "lodash";
export default {
  name: "LocationOverviewRelation",
  data: () => {
    return {
      error: false,
      masterTableWidth: 0,
      loadMore: true,
      timeout: 0,
      year: new Date().getFullYear()
    };
  },
  computed: {
    filter: function() {
      return this.$store.state.qtimeReports.teamOverviewFilter;
    },
    officeData: function() {
      if (this.$store.state.qtimeReports.costCenters.length > 0) {
        let officeData = _.cloneDeep(
          this.$store.state.qtimeReports.costCenters
        );
        officeData.push({
          ItemId: 0,
          OfficeName: "Choose office"
        });
        return officeData;
      }
      else{
        let officeData = [];
        officeData.push({
          ItemId: 0,
          OfficeName: "Choose office"
        });
        return officeData;
      }
    },
    teamData: function() {
      if (this.$store.state.qtimeReports.teams.length > 0) {
        let teamData = _.cloneDeep(
          this.$store.state.qtimeReports.teams
        );
        teamData.push({
          ItemId: 0,
          TeamName: "Choose team"
        });
        return teamData;
      }
      else{
        let teamData = [];
        teamData.push({
          ItemId: 0,
          TeamName: "Choose team"
        });
        return teamData;
      }
    },
    employeeData: function() {
      let employeeData = _.cloneDeep(
        this.$store.state.qtimeReports.employeesInTeam.filter(
          x =>
            x.TeamId ===
              this.$store.state.qtimeReports.teamOverviewFilter
                .TeamId &&
            this.$store.state.qtimeReports.teamOverviewFilter.TeamId >
              0
        )
      );

      if (employeeData != null) {
        employeeData.push({
          ItemId: 0,
          EmployeeName: "Choose Employee"
        });
        
        return employeeData;
      }
      else{
        let employeeDataInit = [];
        employeeDataInit.push({
          ItemId: 0,
          EmployeeName: "Choose Employee"
        });

        return employeeDataInit;
      }
    },
    office: {
      get: function() {
        if (this.$store.state.qtimeReports.costCenters.length > 0) {
          return this.officeData.find(
            x =>
              x.ItemId ===
              this.$store.state.qtimeReports.locationOverviewFilter.CostCenterId
          );
        }

        //return this.$store.state.qtime.filter.ProjectId;
      },
      set: function(value) {
        this.$store.commit("setlocationOverviewFilterCostCentreId", value);
      }
    },
    team: {
      get: function() {
        if (this.$store.state.qtimeReports.teams.length > 0) {
          return this.teamData.find(
            x =>
              x.ItemId ===
              this.$store.state.qtimeReports.teamOverviewFilter.TeamId
          );
        }

        //return this.$store.state.qtime.filter.ProjectId;
      },
      set: function(value) {
        this.$store.commit("setteamOverviewFilterTeamId", value);
      }
    },
    employee: {
      get: function() {
        return this.employeeData.find(
          x =>
            x.ItemId ===
            this.$store.state.qtimeReports.teamOverviewFilter.EmployeeId
        );
        //return this.$store.state.qtime.filter.ProjectId;
      },
      set: function(value) {
        this.$store.commit("setteamOverviewFilterEmployeeId", value);
      }
    },
    officeClassObject: function() {
      return { "error-border": this.error };
    },
    years() {
      const year = new Date().getFullYear();
      let years = Array.from(
        { length: year - 2017 },
        (value, index) => 2018 + index
      );
      return years;
    }
  },
  beforeMount() {
    this.fetchUpdatedReport();
  },
  methods: {
    fetchUpdatedReport: function() {
      this.$store.dispatch("fetchTeam");
    },
    exportExcel: function() {
      if (this.team !== undefined && this.team.ItemId > 0) {
        this.error = false;
        let filter = _.cloneDeep(this.filter);
        // send request
        this.$store.dispatch("exportTeamOverview", filter);
      } else {
        this.error = true;
      }
    },
    setYear() {
      this.$store.commit("setlocationOverviewFilterYear", this.year);
    }
  },
  updated() {},
  mounted() {},

  destroyed() {},
  watch: {}
};
</script>
<style scoped>
.error-border {
  border: 1px solid red;
}

.table-row {
  padding: 20px 20px 10px 20px;
  background: none;
  border: 1px solid rgba(192, 192, 192, 0.3411764705882353);
  border-radius: 11px;
}

.qtime-activity-view {
  width: 100%;
}

.table-row .position {
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 10px;
}

.month-year-label {
  margin-bottom: 10px;
}

.download-button-wrapper {
  width: 100%;
  text-align: center;
}

.cta-btn {
  padding: 7px 19px;
  margin: 0 auto;
}


.sub-header .date-range,
.sub-header{
  border-top: none !important;
  border-bottom: none !important;
}

.table-row{
  height: 206px;
}



@media screen and (max-width: 1573px){
  .sub-header .date-range{
      padding-left: 0;
      }
}
</style>